import script from "./DatasetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetHeader.vue?vue&type=style&index=0&id=1928f754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1928f754"]])

export default __exports__